import React, { ReactElement } from "react";
import { StepProps } from "../TradeModal";

export default function ExternalBrokerError(props: StepProps): ReactElement {
  props.setTitle(`External Action Required by ${props.state.brokerName}`);

  return (
    <div>
      <p>
        Error with your broker, please visit your broker's website and follow
        their instruction for trading on another platform.
      </p>
    </div>
  );
}
